// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";
/* CSS Document */

:root{
	--main-primary: #799F3F;
	--main-secondary: #ADD137;
	--mobile-buttons: #CF7B32;
	--accent-color: #F89B3C;
	--gradient-accent-color: #E38221;
	--accent-green: #85B33E;
	--gradient: top, var(--main-secondary) 0%,var(--main-primary) 100%;
	--gradient-ToBottom: to bottom, var(--main-secondary) 0%,var(--main-primary) 100%;
	
}

div.propMainGridButtons {
	margin-bottom: 10px;
}

/* PF-1236 - edit control text directly */
div.pf-editable {
	/* Marker class. Any form or report control having this class intended to be inline-editable via double-click  */
}

.appLogo{
	max-height: 50px!important;
	width: auto!important;
}

.inline-editor {
	position: absolute;
	left: 0px;
	top: 0px;
    z-index: 99999;
    color: #2d2d2d !important;
	padding: 0!important;
}

.inline-editor::-webkit-input-placeholder {
    background-color: #000000 !important;
    color: #ffffff !important;
}

.inline-editor:-moz-placeholder { /* Firefox 18- */
    background-color: #000000 !important;
    color: #ffffff !important;
}

.inline-editor::-moz-placeholder {  /* Firefox 19+ */
    background-color: #000000 !important;
    color: #ffffff !important;
}

.inline-editor:-ms-input-placeholder {
    background-color: #000000 !important;
    color: #ffffff !important;
}

/*--------- end of PF-1236  inline edit classes --------- */

 /*PF-1270 -- Don't let Chrome impose its own blue focus outline on page and form */

 #aForm {
	width: 100%; 
	min-height: 100%;
	overflow: auto;
 }

 #aForm, #aPageSel {
    outline:none !important;
}

.pf-html-text h1,
.pf-html-text h2,
.pf-html-text h3,
.pf-html-text h4,
.pf-html-text h5,
.pf-html-text h6{
	font-size: revert;
	font-weight: revert;
	margin: revert;
	font-family: revert;
}

/* PF-8373 Fix for IE10+ */
@media (-ms-high-contrast: none), (-ms-high-contrast: active) {

	.pf-html-text h1,
	.pf-html-text h2,
	.pf-html-text h3,
	.pf-html-text h4,
	.pf-html-text h5,
	.pf-html-text h6{
		font-weight: bold!important;
		font-family: "Arial, Helvetica, sans-serif"!important;
	}
	.pf-html-text h1{
		font-size: 1.5em!important;
	}
	.pf-html-text h2{
		font-size: 1.4em!important;
	}
	.pf-html-text h3{
		font-size: 1.3em!important;
	}
	.pf-html-text h4{
		font-size: 1.2em!important;
	}
	.pf-html-text h5{
		font-size: 1.1em!important;
	}
	.pf-html-text h6{
		font-size: 1em!important;
	}

	
}

/*.title-pane {
	background-color: #c0d382;
	display:table-row;
	height: 30px;
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(27, 27, 27, 0.6);
}*/

.toolMarginTop {
	/*margin-top: 5px;
	margin-bottom: 5px;*/
	margin: 10px 0 26px 0;
	display: flex;
    align-items: center;
    justify-content: center; 
    padding: 0;
}

*:focus {
	outline: none;
}

.toolbar-pane {
	/*height: 50px;*/
	height: 123px;
	display:table-row;
}

.toolbox-pane {
	height:90px;
	/*display:table-row;*/
	display: none;
}

.device-buttons div {
	float: left;
	padding: 5px;
}



.device-buttons img, .form-buttons img {
	height: 40px;
}

.device-buttons img:hover, .form-buttons img:hover {
	cursor: pointer;
}

.form-buttons div {
	float: right;
	padding: 5px;
}

.form-buttons {
	min-width: 220px;
	float: right;
}



/*.control-groupbar div {
	float: left;
	padding: 2px;
    box-shadow: 0 -13px 1px rgba(0, 0, 0, 0.075) inset, 0 0 1px rgba(27, 27, 27, 0.6);
}
.control-groupbar {
	margin-top: 15px;
	height: 45px;

}
.control-groupbar div {
	border: solid 1px;
    padding-left: 10px;
    padding-right: 10px;
    height: 25px;
	border-color: #c0d382;
	min-width: 100px;
    text-align: center;
}
.control-groupbar div.search {
	border: none;
	padding:0px;
	box-shadow:none;
}

.control-groupbar div.grp-button:hover {
	cursor:pointer;
	background-color: #c0d382;
}

.control-group-selected {
	background-color: #c0d382;
}

#groupAll {
	border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

#groupLayout {
	border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}*/



.title-pane div {
	font-size: 18px;
	font-family: tahoma;
}

.filterObjects div {
	float: left;
}
.filterObjects select {
	margin:5px;
	width: 150px;
}
.filterObjects img {
	height:25px;
	margin-left: 5px;
}

/*.search.search-toolbox {
	float:right;
}*/

/*.search input {
	border-radius: 4px;
	padding-left: 5px;
    margin-left: 5px;
}*/

.page-search {
	margin-top: 20px;
}


/* Override Bootstrap for this */
/*textarea:focus,
input[type="text"]:focus,
input[type="password"]:focus,
input[type="datetime"]:focus,
input[type="datetime-local"]:focus,
input[type="date"]:focus,
input[type="month"]:focus,
input[type="time"]:focus,
input[type="week"]:focus,
input[type="number"]:focus,
input[type="email"]:focus,
input[type="url"]:focus,
input[type="search"]:focus,
input[type="tel"]:focus,
input[type="color"]:focus,
.uneditable-input:focus,
select:focus {
  border-color: rgba(126, 239, 104, 0.8);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(126, 239, 104, 0.6);
  outline: 0 none;
}*/

/* Changed by BT
.editor-content {

	padding:0;
	display:table-row;
	height:100%;
}
.thumbnail-pane {
	<!--	background-color: blue; -->
	height:100%;
	overflow-y: auto;
	padding-left: 5px;
	padding-right: 5px;
}
*/

.thumbnail-pane .thumbnail-border {
	height:80%;
	border: solid 1px;
	border-color: #c0d382;
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(126, 239, 104, 0.6);
	background-color: #E8F5BD;
	overflow-y: auto;
	border-radius:4px;
	padding-left: 5px;
}
.thumbnail-pane .ui-accordion-header, .thumbnail-pane .ui-accordion-content {
	border: none;
}

/*
.property-pane {
	height: 100%;
	padding-left: 5px;
	padding-right: 5px;
	overflow: auto;
}
.property-pane .property-pane-border {
	height:100%;
	border: solid 1px;
	border-color: #c0d382;
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(126, 239, 104, 0.6);
	background-color: #E8F5BD;
	overflow-y: auto;
	border-radius:4px;
	padding-left: 5px;
}
*/

/*.editor-pane {
	background-color: #EAE9E9;
	height:100%;
	border-radius:4px;
}*/

.toolbox-pane .scroll-content-item {
	font-size: 14px;
}

.toolbox-pane .scroll-content-item img {
	height: 40px;
	vertical-align: top;
}


.ui-widget-header {
	border:none;
	background: none;
}

.scroll-content-item:hover {
	cursor: pointer;
	border-color: rgba(126, 239, 104, 0.8);
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(126, 239, 104, 0.6);
}

#ui-datepicker-div, .new-font-size {
	font-size: 11px !important;
}



.object-list-header:hover {
	cursor:pointer;
}

.thumbnail-page-tile {
	font-weight:bold;
}
.thumbnail-page-tile img {
	margin-left: 10px;
}
#footer {
	display:table-row;
	height: 10px;
}
.stage-role-border {
	height: 19%;
	border: solid 1px;
	border-radius: 4px;
	margin-top: 5px;
	border-color: #c0d382;
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(126, 239, 104, 0.6);
	background-color: #E8F5BD;
}
.stage-dropdown select, .role-dropdown select {
	width: 150px;
	margin-top: 5px;
}
.stage-dropdown label, .role-dropdown label {
	width: 50px;
	font-weight:normal;
	padding-left: 5px;
}
.stage-role-border .pf-short-button {
	float: left;
}
.pf-short-button {
	background-color: #85abda;
	margin: 2px;
	border-radius: 3px;
	padding-left: 5px;
	padding-right: 5px;
	color: white;
	display: block;

}
.pf-short-button:hover {
	cursor:pointer;
}
.thumbnail-border .pf-short-button {
	width: 120px;
	margin-left: 25px;
}
.thumbnail-border ul {
	list-style-type: none;
}

.thumbnail-border img {
	background-color: white;
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(27, 27, 27, 0.6);
	margin-top: 5px;
	margin-bottom: 5px;
}

/*
BT - Start Changes
*/

.scroll-pane { overflow: auto; width: 99%; float:left; width: 4500px; }
/*.scroll-content { width: 2440px; float: left; }*/
.scroll-content-item { width: 85px; height: 40px; float: left; margin: 10px; font-size: 14px; text-align: center; margin-bottom: 20px; border: solid 1px; border-radius: 4px;}
.scroll-bar-wrap { clear: left; padding: 0 4px 0 2px; margin: 0 -1px -1px -1px; }
.scroll-bar-wrap .ui-slider { background: none; border:0; height: 2em; margin: 0 auto;  }
.scroll-bar-wrap .ui-handle-helper-parent { position: relative; width: 100%; height: 100%; margin: 0 auto; }
.scroll-bar-wrap .ui-slider-handle { top:.2em; height: 1.0em; background:none; background-color: #c0d382; }
.scroll-bar-wrap .ui-slider-handle .ui-icon { margin: -8px auto 0; position: relative; top: 50%; }

#toolbar-pane .tab-content {
	height: 68px;
}

#toolbar-pane .tab-pane {
	overflow: auto;
	height: 68px;
	padding: 0;
}

#property-tabs .tab-content {
	font-size: 11px;
	min-width: 255px;
}

#factories {
	width: 100%;
}

#toolbar-pane .tab-content > .tab-pane {
	padding: 0px;
}

#left-rail .tab-pane{
	padding: 0px;
}

.pf-control {
	display: block;
	position: absolute;
}

.pf-control-core {
	cursor: default;
	display: inline;
	float: left;
}
.drag-ghost {
	border: 1px #111111 dashed;
	background-color: transparent;
	position: absolute;
	left: -30000px;
	top: -30000px;

	z-index: 10000;
}

.propDetail {
	width: 100%;
	margin-bottom: 5px;
	display: inline-block;
}
.propDetail label {
	font-weight: normal;
}

.asset-control {
	float:left;
	padding: 5px;
	text-align: center;
	height: 50px;
	width: 50px;
}

.asset-control label {
	font-size: 10px;
	font-weight: normal;
}
.asset-control:hover {
	cursor: pointer;
	background-color: #c0d382 !important;
}
.control-movie {
	background: #000;
}

.prop-label {
	font-weight: bold;
	font-size: 1.2rem;
}

.prop-sublabel {
	padding-top: 5px !important;
	font-size: 11px;
}

.prop-separator-0 {
	margin-top: 0 !important; 
    padding-top: 0 !important;
}

.prop-separator-1 {
	margin-top: 1px !important;  
}

.prop-separator-radio {
	padding-top: 0 !important; 
	max-height: 16px;
}

.prop-sublabel-7 {
	padding-top: 7px !important;
}

#propNavPosition div.nav-position.prop-detail input[type="text"] {
	width: 42px;
}

select {
	width: 100%;
	height: 32px;
	background-color: #fff;
	border-radius: 4px;
	border: 1px solid #bbb;
}

/* Spectrum Override */
.sp-preview {
	position: relative;
	width: 15px;
	height: 15px;
	border: solid 1px #222;
	margin-right: 0px;
	float: left;
	z-index: 0;
}

.sp-dd {
	padding: 2px 0;
	height: 16px;
	line-height: 16px;
	float: left;
	font-size: 10px;
	display: none;
}

.themeTextRows {
	/* padding-left: 15px; */
}

.themeTextRows .style-font-size {
	width: 50px;
}

.themeTextRows .style-font {
	width: 80px;
}
.themeTextRows label {
	font-weight: normal;
}

.weightSelector, .styleSelector {
	border: 1px solid #bbb;
	border-radius: 4px;
	height: 32px;
	width: 25px;
}

.themeTextRows .style-border-size, .themeTextRows .style-border-radius {
	width: 50px;
}

.property-tabs .tab-pane {
	width: 460px;
}

.pf-underline-dashboard{
	border-bottom: 1px solid;
	margin-bottom: 10px;
}

.pf-divider-vertical {
	height: 30px;
	margin: 0 0 0 9px;
	padding: 0 0 0 9px;
	border-left: 1px solid darkgray;
}

.pf-disable{
	pointer-events: none;
}

.pf-enable{
	pointer-events: all;
}


.login-form .login-privacy-policy{
	text-align: center;
	font-size: 10px;
	margin-top:10px!important;
}

.login-form {
	width: 575px;
	height: auto;
	border: 1px solid #ccc;
	background-color: #ffffff;
	position: relative;
	border-style: solid;
	border-width: thin;
	border-radius: 10px;
	padding: 25px;
	box-shadow: 0 2px 9px rgba(0,0,0,0.4);
	font-size: 12px;
	display: table;	
	color:#333333;
}


.login-form .column-logo {
	text-align: center;
}

.login-form img {
	width: 285px;
	height: auto;
	margin-bottom: 20px;
}

.login-form .row {
	margin: 0;
}

.login-form a {
	color: #333333;
}



.login-heading {
	background: var(--main-primary) !important;
	background-image: -moz-linear-gradient(var(--gradient)) !important;
	background-image: -webkit-linear-gradient(var(--gradient)) !important;
	background-image: linear-gradient(var(--gradient-ToBottom)) !important;
	border-top: 0px;
	color: #fff;
	padding: 2px 5px;
	border-top-left-radius: 1px;
	border-top-right-radius: 1px;
	height: 30px;
}

.login-header-text{
	font-weight: bold !important;
	font-size: 18px;
	padding-top: 3px;
}

.login-small-label{
	font-size: 11px;
}


/*This solves an issue with bold on firefox(too bold)*/
@-moz-document url-prefix() {

}

.login-form .login-data {
	margin: 0 15px;
}

.login-container{
	margin: 0 40px!important;
}

.login-container .login-data > .form-group > div, 
.login-container .login-data > .form-group > div  { 
	padding-left: 0;
	padding-right: 0;
	margin-bottom: 7px;
}

.login-container .login-data > .form-group > .no-margin { 
	margin-bottom: 0;
}

.login-container .login-data .error-message { 
	text-align: center;
}

.login-container .login-data .error-message-text {
	margin: 5px 0 4px 0;
}

.login-container .login-data .rememberme-content {
	display: inline-flex; align-items: center; height: 25px;
}

.login-container .login-data .rememberme-content label {
	margin: 0 0 0 5px; font-weight: normal;
}

.login-container .login-data .login-button {
	text-align: center;
}

.login-container .login-data .login-button .button-login-align {
	margin-right: 10px;
}

.login-container .login-data .captcha-container {
	margin-bottom: 0;
    margin-top: 5px;
	font-size: 20px;
}

.login-container .login-data .forgot-password {
	padding-top:2px;
	text-align: right;
}

.login-container .login-data .button-trial-account {
	text-align: right; 
	display: block !important;
}

.login-container .login-data .message-shown-flash-mobile {
	display: inline-flex; height: 252px; align-items: center;
}
 
.login-container .login-data .message-shown-flash-mobile > i {
	color: red; font-size: 25px; margin-right: 5px;
}

.login-container .login-data .message-shown-mobile {
	display: inline-flex; align-items: center;
}

.login-container .login-data .message-shown-mobile  > i {
	color: orange; font-size: 25px; margin-right: 5px;
}

.login-container .login-data .message-shown-mobile  > label, 
.login-container .login-data .message-shown-flash-mobile > label {
	font-weight: normal; line-height: normal; text-align: left;
}


.login-form .login-label{
	font-weight: normal;
}

.login-form .login-data .form-control {
	height: 25px;
	font-size: 12px;
	padding: 4px 12px;
}

.login-form .btn-login{
	background: linear-gradient(var(--gradient-ToBottom));
}

.login-form .button-login {
	width: 100px;
	height: 25px;
	border-radius: 4px;
	font-weight: bold;
	border: 1px solid #d5d5d5;
	padding: 0;
	font-size: 12px;
}

@media screen and (max-width: 736px) { 
	.login-form {
		width: 100%;		
		height: auto;		 
		display: block;	
		padding: 10px;
	}

	.login-form .login-column {
		display: block;
		width: 100%;	
		height: auto;
		max-height: none;
	} 
}

@media screen and (max-width: 400px) {  
	.login-form .column-logo img {
		width: 80% !important;
	}
}

@media screen and (max-width: 736px) and (orientation: landscape) { 
	.login-form {
		width: 80%;
		height: auto;		 		 
		padding: 5px;
	}

	#newUser > div {
		margin-bottom: 0;
	} 

	.login-form .login-column img {
		width: 50%;
	}
}

.login-background {
	background-color: #B7C2F4;
	height:100%;
	background: #a1bde2; /* For browsers that do not support gradients */
	background: -webkit-linear-gradient(#a1bde2, #ffffff); /* For Safari 5.1 to 6.0 */
	background: -o-linear-gradient(#a1bde2, #ffffff); /* For Opera 11.1 to 12.0 */
	background: -moz-linear-gradient(#a1bde2, #ffffff); /* For Firefox 3.6 to 15 */
	background: linear-gradient(#a1bde2, #ffffff); /* Standard syntax */
}

.login-main-container {
	display: -ms-flexbox;      
	display: -webkit-flex;
	display: flex; 
    align-items: center;
	justify-content: center;
}



.form-horizontal .form-group .form-control {	 
	height: 25px;
	padding: 6px 12px;
}

 
#selectAccount #users-list {
	height: 70px;
}


.new-user-container .form-group div:nth-child(2) {
	display: inline-flex;
}

.new-user-container .form-group div:nth-child(2) > .form-control {
	width: 97%;
}

.new-user-container .form-group div:nth-child(2) > .control-label {
	width: 3%;
	color: red;
	text-align: right;
	padding: 5px 0 0 0;
    margin: 0;
}


.align-right {
	float: right;
}


.pre-scrollable {
	overflow-y: auto;
}

.error-message {
	color: #ff5f5f;
}





#content {
	height: 100%;
	display: inline !important;
}


/*
#dynamic-filter, #override-previous{
	padding: 0 0 0 0
}

#respect-dynamic-filter {
	padding: 0 0 0 0;
}
*/


#dashboard-main-panel .pf-btn-small{
	padding:5px 5px 5px 5px
}

#propMainGridButtons .pf-btn-no-padding{
	padding:5px 5px 5px 5px;

}

#propMainGridButtons button{
	font-size: 11px;
}
#propMainGridButtons{

}

button.pf-sm-bootstrap-button{
	font-size: 11px;
}

#gridButtonSection{
	padding-left: 4px;
}

.selectSeparators{
	width: 100% !important;
}

.input-style-border-radius{
	width:50px !important;
}

.column-selection{
	background: rgba(0, 0, 0, 0.1) !important;
	opacity: 0.5;
	border-bottom: none gainsboro !important;
}

.help-margin-page {
	left: 18px;
}

.help-margin-stage{
	right: 3px;
	margin-top: 15px;
}

.ui-jqgrid > .ui-jqgrid-resize-mark, body > .ui-jqgrid-resize-mark{
	background-color: #777 !important;
	width: 3px !important;
}

.emptyResizeColumn{
	height: 25px;
	width:.3em;
	position:relative;
	display:inline;
	overflow: hidden;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	float: right;
}

.ui-tooltip {
	white-space: pre-line;
}

.leftButton{
	margin-right: 150px !important;
}

img#modalResizeHandler {
	position: absolute;
	bottom: 1px;
	right: 1px;
}

@media screen and (max-height: 500px) {
	#aForm {
		overflow-y: scroll;
	}  
}

@media (min-width: 1200px) {
	#nav-menu-mobile {
		display: none;
	}

	#nav-menu-desktop {
		display: block;
	}
}


@media (max-width: 1200px) {
	#nav-menu-mobile {
		display: block;
	}

	#nav-menu-desktop {
		display: none;
	}

	.navbar-nav > li {
		float: left !important;
		display: block;
		text-align: center; 
	}

	.navbar-left > li a {
		padding-left: 0 !important;
	}

	.quick-help .closed-tag{
		margin-right: -28px!important;
	}
}

/*Refresh connections*/

.refresh-actions {
	padding-top: 2px;
	padding-left: 8px;
	text-align: end;
}
.refresh-actions-new {
	padding-top: 0px;
	padding-left: 8px;
	text-align: end;
}

.noselect {    
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

#loading {
	display: none;
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.3);
	width: 100%;
	height: 100%;
	z-index: 1109;
	filter: alpha(opacity = 90);
	opacity: 0.90;
	-ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity = 90);
	filter: alpha(opacity = 90);
}
#loading-div {
	width: 200px;
	height: auto;
	background-color: white;
	text-align: center;
	position: absolute;
	left: 50%;
	top: 50%;
	margin-left: -150px;
	margin-top: -100px;
	border-radius: 5px;
	padding-bottom:10px;
	padding-top:10px;
}

.disable_a_href{
    pointer-events: none;
}

.dropdown-menu > li > a > span.keyboard-shortcut,
.dropdown-menu > li > a > span > span.keyboard-shortcut {
	float: right;
    font-style: italic;
    color: lightgrey;
}

.lstlink .dropdown-menu::before,
.lstlink .dropdown-menu::after {
	border: none;
	content: none;
}

.lstlink .navbar-btn {
	margin-top:0px !important;
	margin-bottom: 0px !important;
}

.close-icon-asset {
	border: 1px solid transparent;
	background-color: transparent;
	display: block;
  	outline: 0;
	cursor: pointer;
}

.close-icon-asset:after {
	content: "X";
    display: block;
    width: 15px;
    height: 15px;
    position: absolute;
    background-color: var(--main-secondary);
    z-index: 1;
    top: 24px;
    right: 20px; 
    margin: auto;
    padding: 0;
    border-radius: 50%;
    text-align: center;
    color: white;
    font-weight: normal;
    font-size: 12px;
    box-shadow: 0 0 2px var(--main-secondary);
    cursor: pointer;
}

.file-asset-import {
	width: 90px !important;  border-radius: 4px !important; height: 28px !important;
} 

#file-asset-label {
	width: 25%; border-radius: 4px 0px 0px 4px; height: 30px;margin-top: -1px;
}

#file-asset-name {
	width: 75%;height: 30px;
	border-radius: 0 4px 4px 0px;
    margin-left: -5px;
    margin-bottom: 5px;
    border: 1px solid #d5d5d5;
    box-shadow: 0px 2px 5px #d5d5d5;
    -moz-box-shadow: 0px 2px 5px #d5d5d5;
    -webkit-box-shadow: 0px 2px 5px #d5d5d5;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

#asset-error-msg {
	margin-left: 117px; color:red; font-weight: bold;
}

#assetViewerContainer {
	text-align: center; height: 300px; width: 500px; display: none; vertical-align: middle;
}

.vertical{
	line-height: 25px;
}
.vertical input[type=text]{
	margin-right: 5px;
}
.vertical img{
	height: 25px !important;
	width: 25px !important;
	vertical-align: middle;
	margin-top:-2px;
}
.calen-selected{
	opacity: 0.4;
}
.calen-normal{
	opacity: 1.0;
}
.tbl-icon{
	width:  25px !important;
	height:  25px !important;
	font-size:  16px !important;
	background: #ababab;
	padding:  2px 2px !important;
	color: #ffffff;
	border-right-color:  #a8a8a8;
	border-bottom-color:  #a8a8a8;
	margin-top: 2px;
}

.tbl-button-text{
	height:  25px !important;
	font-size:  12px !important;
	padding:  2px 2px !important;
	margin-top: 2px;
}
	

.tbl-icon:hover, .tbl-icon-lst:hover{
	background: #ababab !important;
	color: #ffffff !important;

}
.tbl-icon-data-lst:hover, .tbl-icon-data-lst:active, .tbl-icon-data-lst:focus, .tbl-icon-data-lst:visited, .tbl-icon-data-lst:focus-within{
	background: #ababab !important;
	color: #ffffff !important;
	-webkit-box-shadow: none !important;
	-moz-box-shadow: none !important;
	box-shadow: none !important;

	border-right-color: #a8a8a8;
	border-bottom-color: #a8a8a8;
	border-top-color: rgb(213, 213, 213);
	border-top-style: solid;
	border-top-width: 1px;
	pointer-events: none;

}

.btn-ctrl-data{
	margin: 0px;
	height: 20px;
	width: 20px;
}
.btn-ctrl-datas{
	margin: 0px;
	height: 20px;
	width: 12px;
	margin-left: 3px;
	margin-right: 2px;
}

.tbl-icon-data-lst{
	padding:2px 2px !important;
	margin-top: 2px ;
	background: #ababab;
	color: #ffffff;
	border-right-color:  #a8a8a8;
	border-bottom-color:  #a8a8a8;
	cursor: default !important;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	-moz-user-select: -moz-none;
	-khtml-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	user-select: none;
	-moz-user-select: none;
	/* Required to make elements draggable in old WebKit */
	-webkit-user-drag: element;
	pointer-events: none;
}

.no-box{
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
}

.tbl-icon-data-lst:hover{
	background: #ababab;
	color: #ffffff;
	border-right-color:  #a8a8a8;
	border-bottom-color:  #a8a8a8;
	cursor: default !important;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
}

.tbl-icon-lst{
	width:  25px !important;
	height:  25px !important;
	font-size:  16px !important;
	background: #ababab;
	color: #ffffff;
	border-right-color:  #a8a8a8;
	border-bottom-color:  #a8a8a8;
	margin-top: 2px;
	padding: 1px !important;
	float: right;
}
#tableControls select{
	/*margin-left: 135px !important;*/
	right: 108px !important;
	width: 61% !important;
}

#tableControls .itemSpaceEvenly{
	right: 0px !important;
}

#tableControls .itemRemove{
	right: 27px !important;
}

#tableControls .itemDown{
	right: 54px !important;
}

#tableControls .itemUp {
	right: 81px !important;
}

.context-item{
	float: left;
}

.actionName{
	display: ruby;
	white-space:nowrap;
}

.bootstrapMenu ul li a, #designerSave, #designerUndo, #designerRedo, #designerPaste, #designerCopy, #designerCut, #designerSelectAll {
	display: grid !important;
}

.forceNotToShrink {
	width: 100% !important;
}
#formulaModal .ui-datepicker-trigger{
	height: 25px !important;
}
.dateValueSpecific ~ img, .ui-datepicker-trigger{
	height: 25px !important;
	width: 25px !important;
	vertical-align: middle;
	margin-top:-1px;
	margin-left: 3px !important;
}
.pf-icon-up{
	-moz-transform: rotate(-180deg);  /* FF3.5/3.6 */
	-o-transform: rotate(-180deg);  /* Opera 10.5 */
	-webkit-transform: rotate(-180deg);  /* Saf3.1+ */
	transform: rotate(-180deg);  /* Newer browsers (incl IE9) */
}
.pf-icon-special-small{
    width:1.3em;
    top:3px;
    left:-1px;
}
.pf-stack-icon-special{
    top: -5px;
    font-size: inherit;
}
.pf-icon-list-special{
    font-size: 14px;
    height: 32px;
}
.control-selected{
	border: 1px dotted #ffffff;
}

.disable-select {
    user-select: none; /* supported by Chrome and Opera */
   -webkit-user-select: none; /* Safari */
   -khtml-user-select: none; /* Konqueror HTML */
   -moz-user-select: none; /* Firefox */
   -ms-user-select: none; /* Internet Explorer/Edge */
}

#spinner-overlay {
	position: fixed; /* Sit on top of the page content */
	width: 100%; /* Full width (cover the whole page) */
	height: 100%; /* Full height (cover the whole page) */
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0.05); /* Black background with opacity */
	z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  }

.navigation-objects-list{
	padding: 7px 0px!important;
}

.refresh-dropdown{
	font-size: 16px;
    margin: 5px 0 0 5px;
    cursor: pointer;
}

.website{
	text-align: center;
	font-family: Poppins;
}

.website a{
	color: var(--main-primary);
    font-weight: bold;
}

/* Styles for the translate icon container */
.input-with-icon {
	position: relative;
}
.input-with-icon .app-title {
	padding-right: 35px; 
	width: 100%; 
}

.translate-icon {
	position: absolute;
	right: 6px; 
	transform: translateY(-50%);
	cursor: pointer;
	color: #888;
	opacity: 0.7;
	transition: opacity 0.2s;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}

/* top for inputs */
.input-with-icon:not(.textarea-icon-wrapper) .translate-icon {
	top: 50%;
	transform: translateY(-50%);
}

/* specific alignment for textareas */
.textarea-icon-wrapper .translate-icon {
	top: 30px; 
}

.translate-icon:hover {
	opacity: 1;
}

.translate-icon i {
	font-size: 1.5rem;
}

.chat-bot{
	position: fixed;
    right: 0;
    bottom: 0;
    width: 80px;
    height: 80px;
    background-color: var(--accent-color, #F89B3C);
    margin: 20px;
    border-radius: 15px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    cursor: pointer;
    z-index: 9999;
}`, "",{"version":3,"sources":["webpack://./assets/style/pf.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,iBAAiB;;AAEjB;CACC,uBAAuB;CACvB,yBAAyB;CACzB,yBAAyB;CACzB,uBAAuB;CACvB,gCAAgC;CAChC,uBAAuB;CACvB,kEAAkE;CAClE,iFAAiF;;AAElF;;AAEA;CACC,mBAAmB;AACpB;;AAEA,yCAAyC;AACzC;CACC,gHAAgH;AACjH;;AAEA;CACC,0BAA0B;CAC1B,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;IACL,cAAc;IACd,yBAAyB;CAC5B,oBAAoB;AACrB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,kCAAkC,gBAAgB;IAC9C,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,oCAAoC,gBAAgB;IAChD,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,2DAA2D;;CAE1D,kFAAkF;;CAElF;CACA,WAAW;CACX,gBAAgB;CAChB,cAAc;CACd;;CAEA;IACG,uBAAuB;AAC3B;;AAEA;;;;;;CAMC,iBAAiB;CACjB,mBAAmB;CACnB,cAAc;CACd,mBAAmB;AACpB;;AAEA,0BAA0B;AAC1B;;CAEC;;;;;;EAMC,2BAA2B;EAC3B,qDAAqD;CACtD;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,wBAAwB;CACzB;;;AAGD;;AAEA;;;;;EAKE;;AAEF;CACC;qBACoB;CACpB,qBAAqB;CACrB,aAAa;IACV,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;;;AAIA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0CE;;;;AAIF;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;AACA;CACC,UAAU;CACV,YAAY;AACb;AACA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;;EAEE;;AAEF;;;;EAIE;;AAEF;CACC,gBAAgB;AACjB;;;AAGA,gCAAgC;AAChC;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;;;;;;;;;;;;;;CAcC;;AAED;CACC,UAAU;CACV,iBAAiB;CACjB,qBAAqB;CACrB,kFAAkF;CAClF,yBAAyB;CACzB,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,YAAY;AACb;;AAEA;;;;;;;;;;;;;;;;;CAiBC;;AAED;;;;EAIE;;AAEF;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,mBAAmB;AACpB;;;AAGA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,sCAAsC;CACtC,kFAAkF;AACnF;;AAEA;CACC,0BAA0B;AAC3B;;;;AAIA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;CACjB,YAAY;AACb;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,qBAAqB;CACrB,kFAAkF;CAClF,yBAAyB;AAC1B;AACA;CACC,YAAY;CACZ,eAAe;AAChB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,iBAAiB;AAClB;AACA;CACC,WAAW;AACZ;AACA;CACC,yBAAyB;CACzB,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,cAAc;;AAEf;AACA;CACC,cAAc;AACf;AACA;CACC,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,uBAAuB;CACvB,+EAA+E;CAC/E,eAAe;CACf,kBAAkB;AACnB;;AAEA;;CAEC;;AAED,eAAe,cAAc,EAAE,UAAU,EAAE,UAAU,EAAE,aAAa,EAAE;AACtE,kDAAkD;AAClD,uBAAuB,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,kBAAkB,CAAC;AAC7K,mBAAmB,WAAW,EAAE,oBAAoB,EAAE,wBAAwB,EAAE;AAChF,8BAA8B,gBAAgB,EAAE,QAAQ,EAAE,WAAW,EAAE,cAAc,GAAG;AACxF,4CAA4C,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AAC3G,qCAAqC,QAAQ,EAAE,aAAa,EAAE,eAAe,EAAE,yBAAyB,EAAE;AAC1G,8CAA8C,mBAAmB,EAAE,kBAAkB,EAAE,QAAQ,EAAE;;AAEjG;CACC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,eAAe;CACf,WAAW;AACZ;AACA;CACC,0BAA0B;CAC1B,6BAA6B;CAC7B,kBAAkB;CAClB,cAAc;CACd,aAAa;;CAEb,cAAc;AACf;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,oCAAoC;AACrC;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;CACC,wBAAwB;IACrB,yBAAyB;AAC7B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA,sBAAsB;AACtB;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,iBAAiB;CACjB,WAAW;CACX,UAAU;AACX;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,WAAW;CACX,eAAe;CACf,aAAa;AACd;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,wBAAwB;CACxB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,+BAA+B;AAChC;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;AACpB;;;AAGA;CACC,kBAAkB;CAClB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,aAAa;CACb,qCAAqC;CACrC,eAAe;CACf,cAAc;CACd,aAAa;AACd;;;AAGA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,cAAc;AACf;;;;AAIA;CACC,0CAA0C;CAC1C,kEAAkE;CAClE,qEAAqE;CACrE,sEAAsE;CACtE,eAAe;CACf,WAAW;CACX,gBAAgB;CAChB,2BAA2B;CAC3B,4BAA4B;CAC5B,YAAY;AACb;;AAEA;CACC,4BAA4B;CAC5B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;;AAGA,sDAAsD;AACtD;;AAEA;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB,EAAE,mBAAmB,EAAE,YAAY;AACxD;;AAEA;CACC,iBAAiB,EAAE,mBAAmB;AACvC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;IACb,eAAe;CAClB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB,EAAE,aAAa,EAAE,mBAAmB;AACzD;;AAEA;CACC,UAAU,EAAE,eAAe,EAAE,iBAAiB;AAC/C;;AAEA;CACC,oBAAoB,EAAE,mBAAmB;AAC1C;;AAEA;CACC,aAAa,EAAE,eAAe,EAAE,iBAAiB;AAClD;;AAEA;;CAEC,mBAAmB,EAAE,mBAAmB,EAAE,gBAAgB;AAC3D;;;AAGA;CACC,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,qDAAqD;AACtD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,yBAAyB;CACzB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;CACd;;CAEA;EACC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,UAAU;EACV,YAAY;EACZ,YAAY;CACb;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,UAAU;CACX;AACD;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,mBAAmB,EAAE,+CAA+C;CACpE,qDAAqD,EAAE,0BAA0B;CACjF,gDAAgD,EAAE,2BAA2B;CAC7E,kDAAkD,EAAE,0BAA0B;CAC9E,6CAA6C,EAAE,oBAAoB;AACpE;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;CACrB,aAAa;IACV,mBAAmB;CACtB,uBAAuB;AACxB;;;;AAIA;CACC,YAAY;CACZ,iBAAiB;AAClB;;;AAGA;CACC,YAAY;AACb;;;AAGA;CACC,oBAAoB;AACrB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,SAAS;CACT,UAAU;CACV,iBAAiB;CACjB,kBAAkB;IACf,SAAS;AACb;;;AAGA;CACC,YAAY;AACb;;;AAGA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;;;;;AAMA;CACC,YAAY;CACZ,0BAA0B;AAC3B;;;AAGA;;;;;;;;CAQC;;;AAGD;CACC;AACD;;AAEA;CACC,uBAAuB;;AAExB;;AAEA;CACC,eAAe;AAChB;AACA;;AAEA;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yCAAyC;CACzC,YAAY;CACZ,wCAAwC;AACzC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,iCAAiC;CACjC,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,sBAAsB;CACtB,qBAAqB;CACrB,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,cAAc;CACf;AACD;;;AAGA;CACC;EACC,cAAc;CACf;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,sBAAsB;EACtB,cAAc;EACd,kBAAkB;CACnB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,6BAA6B;CAC9B;AACD;;AAEA,sBAAsB;;AAEtB;CACC,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,MAAM;CACN,OAAO;CACP,8BAA8B;CAC9B,WAAW;CACX,YAAY;CACZ,aAAa;CACb,2BAA2B;CAC3B,aAAa;CACb,iEAAiE;CACjE,2BAA2B;AAC5B;AACA;CACC,YAAY;CACZ,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;CAEC,YAAY;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;CAEC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;CAC7B,6BAA6B;CAC7B,cAAc;GACZ,UAAU;CACZ,eAAe;AAChB;;AAEA;CACC,YAAY;IACT,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,yCAAyC;IACzC,eAAe;AACnB;;AAEA;CACC,sBAAsB,GAAG,6BAA6B,EAAE,uBAAuB;AAChF;;AAEA;CACC,UAAU,EAAE,8BAA8B,EAAE,YAAY,CAAC,gBAAgB;AAC1E;;AAEA;CACC,UAAU,CAAC,YAAY;CACvB,4BAA4B;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;IAC/B,oCAAoC;IACpC,uCAAuC;IACvC,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;CACC,kBAAkB,EAAE,SAAS,EAAE,iBAAiB;AACjD;;AAEA;CACC,kBAAkB,EAAE,aAAa,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB;AACvF;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,uBAAuB;CACvB,sBAAsB;CACtB,sBAAsB;CACtB,eAAe;AAChB;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,uBAAuB;CACvB,wBAAwB;CACxB,2BAA2B;CAC3B,mBAAmB;CACnB,4BAA4B;CAC5B,cAAc;CACd,4BAA4B;CAC5B,6BAA6B;CAC7B,eAAe;AAChB;;AAEA;CACC,wBAAwB;CACxB,2BAA2B;CAC3B,4BAA4B;CAC5B,eAAe;AAChB;;;AAGA;CACC,8BAA8B;CAC9B,yBAAyB;;AAE1B;AACA;CACC,8BAA8B;CAC9B,yBAAyB;CACzB,mCAAmC;CACnC,gCAAgC;CAChC,2BAA2B;;CAE3B,2BAA2B;CAC3B,4BAA4B;CAC5B,oCAAoC;CACpC,uBAAuB;CACvB,qBAAqB;CACrB,oBAAoB;;AAErB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;AACZ;AACA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;CACd,4BAA4B;CAC5B,6BAA6B;CAC7B,0BAA0B;CAC1B,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;CAChB,2BAA2B;CAC3B,wBAAwB;CACxB,yBAAyB;CACzB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,sDAAsD;CACtD,0BAA0B;CAC1B,oBAAoB;AACrB;;AAEA;CACC,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,4BAA4B;CAC5B,6BAA6B;CAC7B,0BAA0B;CAC1B,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,wBAAwB;CACxB,2BAA2B;CAC3B,mBAAmB;CACnB,cAAc;CACd,4BAA4B;CAC5B,6BAA6B;CAC7B,eAAe;CACf,uBAAuB;CACvB,YAAY;AACb;AACA;CACC,iCAAiC;CACjC,uBAAuB;CACvB,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,sBAAsB;AACvB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;CACvB,sBAAsB;CACtB,sBAAsB;CACtB,eAAe;CACf,2BAA2B;AAC5B;AACA;CACC,+BAA+B,GAAG,cAAc;CAChD,6BAA6B,GAAG,eAAe;CAC/C,kCAAkC,GAAG,YAAY;CACjD,0BAA0B,GAAG,8BAA8B;AAC5D;AACA;IACI,WAAW;IACX,OAAO;IACP,SAAS;AACb;AACA;IACI,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;CACC,0BAA0B;AAC3B;;AAEA;IACI,iBAAiB,EAAE,kCAAkC;GACtD,yBAAyB,EAAE,WAAW;GACtC,wBAAwB,EAAE,mBAAmB;GAC7C,sBAAsB,EAAE,YAAY;GACpC,qBAAqB,EAAE,2BAA2B;AACrD;;AAEA;CACC,eAAe,EAAE,mCAAmC;CACpD,WAAW,EAAE,sCAAsC;CACnD,YAAY,EAAE,uCAAuC;CACrD,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,kCAAkC,EAAE,kCAAkC;CACtE,UAAU,EAAE,oFAAoF;EAC/F;;AAEF;CACC,0BAA0B;AAC3B;;AAEA;CACC,eAAe;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,0BAA0B;IACvB,iBAAiB;AACrB;;AAEA,4CAA4C;AAC5C;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,2BAA2B;CAC3B,eAAe;CACf,WAAW;CACX,YAAY;CACZ,wBAAwB;CACxB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;AACb;;AAEA,mBAAmB;AACnB;CACC,QAAQ;CACR,2BAA2B;AAC5B;;AAEA,qCAAqC;AACrC;CACC,SAAS;AACV;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;IACZ,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,YAAY;IACZ,mBAAmB;IACnB,oDAAoD;IACpD,eAAe;IACf,aAAa;AACjB","sourcesContent":["@charset \"utf-8\";\r\n/* CSS Document */\r\n\r\n:root{\r\n\t--main-primary: #799F3F;\r\n\t--main-secondary: #ADD137;\r\n\t--mobile-buttons: #CF7B32;\r\n\t--accent-color: #F89B3C;\r\n\t--gradient-accent-color: #E38221;\r\n\t--accent-green: #85B33E;\r\n\t--gradient: top, var(--main-secondary) 0%,var(--main-primary) 100%;\r\n\t--gradient-ToBottom: to bottom, var(--main-secondary) 0%,var(--main-primary) 100%;\r\n\t\r\n}\r\n\r\ndiv.propMainGridButtons {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n/* PF-1236 - edit control text directly */\r\ndiv.pf-editable {\r\n\t/* Marker class. Any form or report control having this class intended to be inline-editable via double-click  */\r\n}\r\n\r\n.appLogo{\r\n\tmax-height: 50px!important;\r\n\twidth: auto!important;\r\n}\r\n\r\n.inline-editor {\r\n\tposition: absolute;\r\n\tleft: 0px;\r\n\ttop: 0px;\r\n    z-index: 99999;\r\n    color: #2d2d2d !important;\r\n\tpadding: 0!important;\r\n}\r\n\r\n.inline-editor::-webkit-input-placeholder {\r\n    background-color: #000000 !important;\r\n    color: #ffffff !important;\r\n}\r\n\r\n.inline-editor:-moz-placeholder { /* Firefox 18- */\r\n    background-color: #000000 !important;\r\n    color: #ffffff !important;\r\n}\r\n\r\n.inline-editor::-moz-placeholder {  /* Firefox 19+ */\r\n    background-color: #000000 !important;\r\n    color: #ffffff !important;\r\n}\r\n\r\n.inline-editor:-ms-input-placeholder {\r\n    background-color: #000000 !important;\r\n    color: #ffffff !important;\r\n}\r\n\r\n/*--------- end of PF-1236  inline edit classes --------- */\r\n\r\n /*PF-1270 -- Don't let Chrome impose its own blue focus outline on page and form */\r\n\r\n #aForm {\r\n\twidth: 100%; \r\n\tmin-height: 100%;\r\n\toverflow: auto;\r\n }\r\n\r\n #aForm, #aPageSel {\r\n    outline:none !important;\r\n}\r\n\r\n.pf-html-text h1,\r\n.pf-html-text h2,\r\n.pf-html-text h3,\r\n.pf-html-text h4,\r\n.pf-html-text h5,\r\n.pf-html-text h6{\r\n\tfont-size: revert;\r\n\tfont-weight: revert;\r\n\tmargin: revert;\r\n\tfont-family: revert;\r\n}\r\n\r\n/* PF-8373 Fix for IE10+ */\r\n@media (-ms-high-contrast: none), (-ms-high-contrast: active) {\r\n\r\n\t.pf-html-text h1,\r\n\t.pf-html-text h2,\r\n\t.pf-html-text h3,\r\n\t.pf-html-text h4,\r\n\t.pf-html-text h5,\r\n\t.pf-html-text h6{\r\n\t\tfont-weight: bold!important;\r\n\t\tfont-family: \"Arial, Helvetica, sans-serif\"!important;\r\n\t}\r\n\t.pf-html-text h1{\r\n\t\tfont-size: 1.5em!important;\r\n\t}\r\n\t.pf-html-text h2{\r\n\t\tfont-size: 1.4em!important;\r\n\t}\r\n\t.pf-html-text h3{\r\n\t\tfont-size: 1.3em!important;\r\n\t}\r\n\t.pf-html-text h4{\r\n\t\tfont-size: 1.2em!important;\r\n\t}\r\n\t.pf-html-text h5{\r\n\t\tfont-size: 1.1em!important;\r\n\t}\r\n\t.pf-html-text h6{\r\n\t\tfont-size: 1em!important;\r\n\t}\r\n\r\n\t\r\n}\r\n\r\n/*.title-pane {\r\n\tbackground-color: #c0d382;\r\n\tdisplay:table-row;\r\n\theight: 30px;\r\n\tbox-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(27, 27, 27, 0.6);\r\n}*/\r\n\r\n.toolMarginTop {\r\n\t/*margin-top: 5px;\r\n\tmargin-bottom: 5px;*/\r\n\tmargin: 10px 0 26px 0;\r\n\tdisplay: flex;\r\n    align-items: center;\r\n    justify-content: center; \r\n    padding: 0;\r\n}\r\n\r\n*:focus {\r\n\toutline: none;\r\n}\r\n\r\n.toolbar-pane {\r\n\t/*height: 50px;*/\r\n\theight: 123px;\r\n\tdisplay:table-row;\r\n}\r\n\r\n.toolbox-pane {\r\n\theight:90px;\r\n\t/*display:table-row;*/\r\n\tdisplay: none;\r\n}\r\n\r\n.device-buttons div {\r\n\tfloat: left;\r\n\tpadding: 5px;\r\n}\r\n\r\n\r\n\r\n.device-buttons img, .form-buttons img {\r\n\theight: 40px;\r\n}\r\n\r\n.device-buttons img:hover, .form-buttons img:hover {\r\n\tcursor: pointer;\r\n}\r\n\r\n.form-buttons div {\r\n\tfloat: right;\r\n\tpadding: 5px;\r\n}\r\n\r\n.form-buttons {\r\n\tmin-width: 220px;\r\n\tfloat: right;\r\n}\r\n\r\n\r\n\r\n/*.control-groupbar div {\r\n\tfloat: left;\r\n\tpadding: 2px;\r\n    box-shadow: 0 -13px 1px rgba(0, 0, 0, 0.075) inset, 0 0 1px rgba(27, 27, 27, 0.6);\r\n}\r\n.control-groupbar {\r\n\tmargin-top: 15px;\r\n\theight: 45px;\r\n\r\n}\r\n.control-groupbar div {\r\n\tborder: solid 1px;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    height: 25px;\r\n\tborder-color: #c0d382;\r\n\tmin-width: 100px;\r\n    text-align: center;\r\n}\r\n.control-groupbar div.search {\r\n\tborder: none;\r\n\tpadding:0px;\r\n\tbox-shadow:none;\r\n}\r\n\r\n.control-groupbar div.grp-button:hover {\r\n\tcursor:pointer;\r\n\tbackground-color: #c0d382;\r\n}\r\n\r\n.control-group-selected {\r\n\tbackground-color: #c0d382;\r\n}\r\n\r\n#groupAll {\r\n\tborder-top-left-radius: 4px;\r\n    border-bottom-left-radius: 4px;\r\n}\r\n\r\n#groupLayout {\r\n\tborder-top-right-radius: 4px;\r\n    border-bottom-right-radius: 4px;\r\n}*/\r\n\r\n\r\n\r\n.title-pane div {\r\n\tfont-size: 18px;\r\n\tfont-family: tahoma;\r\n}\r\n\r\n.filterObjects div {\r\n\tfloat: left;\r\n}\r\n.filterObjects select {\r\n\tmargin:5px;\r\n\twidth: 150px;\r\n}\r\n.filterObjects img {\r\n\theight:25px;\r\n\tmargin-left: 5px;\r\n}\r\n\r\n/*.search.search-toolbox {\r\n\tfloat:right;\r\n}*/\r\n\r\n/*.search input {\r\n\tborder-radius: 4px;\r\n\tpadding-left: 5px;\r\n    margin-left: 5px;\r\n}*/\r\n\r\n.page-search {\r\n\tmargin-top: 20px;\r\n}\r\n\r\n\r\n/* Override Bootstrap for this */\r\n/*textarea:focus,\r\ninput[type=\"text\"]:focus,\r\ninput[type=\"password\"]:focus,\r\ninput[type=\"datetime\"]:focus,\r\ninput[type=\"datetime-local\"]:focus,\r\ninput[type=\"date\"]:focus,\r\ninput[type=\"month\"]:focus,\r\ninput[type=\"time\"]:focus,\r\ninput[type=\"week\"]:focus,\r\ninput[type=\"number\"]:focus,\r\ninput[type=\"email\"]:focus,\r\ninput[type=\"url\"]:focus,\r\ninput[type=\"search\"]:focus,\r\ninput[type=\"tel\"]:focus,\r\ninput[type=\"color\"]:focus,\r\n.uneditable-input:focus,\r\nselect:focus {\r\n  border-color: rgba(126, 239, 104, 0.8);\r\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(126, 239, 104, 0.6);\r\n  outline: 0 none;\r\n}*/\r\n\r\n/* Changed by BT\r\n.editor-content {\r\n\r\n\tpadding:0;\r\n\tdisplay:table-row;\r\n\theight:100%;\r\n}\r\n.thumbnail-pane {\r\n\t<!--\tbackground-color: blue; -->\r\n\theight:100%;\r\n\toverflow-y: auto;\r\n\tpadding-left: 5px;\r\n\tpadding-right: 5px;\r\n}\r\n*/\r\n\r\n.thumbnail-pane .thumbnail-border {\r\n\theight:80%;\r\n\tborder: solid 1px;\r\n\tborder-color: #c0d382;\r\n\tbox-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(126, 239, 104, 0.6);\r\n\tbackground-color: #E8F5BD;\r\n\toverflow-y: auto;\r\n\tborder-radius:4px;\r\n\tpadding-left: 5px;\r\n}\r\n.thumbnail-pane .ui-accordion-header, .thumbnail-pane .ui-accordion-content {\r\n\tborder: none;\r\n}\r\n\r\n/*\r\n.property-pane {\r\n\theight: 100%;\r\n\tpadding-left: 5px;\r\n\tpadding-right: 5px;\r\n\toverflow: auto;\r\n}\r\n.property-pane .property-pane-border {\r\n\theight:100%;\r\n\tborder: solid 1px;\r\n\tborder-color: #c0d382;\r\n\tbox-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(126, 239, 104, 0.6);\r\n\tbackground-color: #E8F5BD;\r\n\toverflow-y: auto;\r\n\tborder-radius:4px;\r\n\tpadding-left: 5px;\r\n}\r\n*/\r\n\r\n/*.editor-pane {\r\n\tbackground-color: #EAE9E9;\r\n\theight:100%;\r\n\tborder-radius:4px;\r\n}*/\r\n\r\n.toolbox-pane .scroll-content-item {\r\n\tfont-size: 14px;\r\n}\r\n\r\n.toolbox-pane .scroll-content-item img {\r\n\theight: 40px;\r\n\tvertical-align: top;\r\n}\r\n\r\n\r\n.ui-widget-header {\r\n\tborder:none;\r\n\tbackground: none;\r\n}\r\n\r\n.scroll-content-item:hover {\r\n\tcursor: pointer;\r\n\tborder-color: rgba(126, 239, 104, 0.8);\r\n\tbox-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(126, 239, 104, 0.6);\r\n}\r\n\r\n#ui-datepicker-div, .new-font-size {\r\n\tfont-size: 11px !important;\r\n}\r\n\r\n\r\n\r\n.object-list-header:hover {\r\n\tcursor:pointer;\r\n}\r\n\r\n.thumbnail-page-tile {\r\n\tfont-weight:bold;\r\n}\r\n.thumbnail-page-tile img {\r\n\tmargin-left: 10px;\r\n}\r\n#footer {\r\n\tdisplay:table-row;\r\n\theight: 10px;\r\n}\r\n.stage-role-border {\r\n\theight: 19%;\r\n\tborder: solid 1px;\r\n\tborder-radius: 4px;\r\n\tmargin-top: 5px;\r\n\tborder-color: #c0d382;\r\n\tbox-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(126, 239, 104, 0.6);\r\n\tbackground-color: #E8F5BD;\r\n}\r\n.stage-dropdown select, .role-dropdown select {\r\n\twidth: 150px;\r\n\tmargin-top: 5px;\r\n}\r\n.stage-dropdown label, .role-dropdown label {\r\n\twidth: 50px;\r\n\tfont-weight:normal;\r\n\tpadding-left: 5px;\r\n}\r\n.stage-role-border .pf-short-button {\r\n\tfloat: left;\r\n}\r\n.pf-short-button {\r\n\tbackground-color: #85abda;\r\n\tmargin: 2px;\r\n\tborder-radius: 3px;\r\n\tpadding-left: 5px;\r\n\tpadding-right: 5px;\r\n\tcolor: white;\r\n\tdisplay: block;\r\n\r\n}\r\n.pf-short-button:hover {\r\n\tcursor:pointer;\r\n}\r\n.thumbnail-border .pf-short-button {\r\n\twidth: 120px;\r\n\tmargin-left: 25px;\r\n}\r\n.thumbnail-border ul {\r\n\tlist-style-type: none;\r\n}\r\n\r\n.thumbnail-border img {\r\n\tbackground-color: white;\r\n\tbox-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(27, 27, 27, 0.6);\r\n\tmargin-top: 5px;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n/*\r\nBT - Start Changes\r\n*/\r\n\r\n.scroll-pane { overflow: auto; width: 99%; float:left; width: 4500px; }\r\n/*.scroll-content { width: 2440px; float: left; }*/\r\n.scroll-content-item { width: 85px; height: 40px; float: left; margin: 10px; font-size: 14px; text-align: center; margin-bottom: 20px; border: solid 1px; border-radius: 4px;}\r\n.scroll-bar-wrap { clear: left; padding: 0 4px 0 2px; margin: 0 -1px -1px -1px; }\r\n.scroll-bar-wrap .ui-slider { background: none; border:0; height: 2em; margin: 0 auto;  }\r\n.scroll-bar-wrap .ui-handle-helper-parent { position: relative; width: 100%; height: 100%; margin: 0 auto; }\r\n.scroll-bar-wrap .ui-slider-handle { top:.2em; height: 1.0em; background:none; background-color: #c0d382; }\r\n.scroll-bar-wrap .ui-slider-handle .ui-icon { margin: -8px auto 0; position: relative; top: 50%; }\r\n\r\n#toolbar-pane .tab-content {\r\n\theight: 68px;\r\n}\r\n\r\n#toolbar-pane .tab-pane {\r\n\toverflow: auto;\r\n\theight: 68px;\r\n\tpadding: 0;\r\n}\r\n\r\n#property-tabs .tab-content {\r\n\tfont-size: 11px;\r\n\tmin-width: 255px;\r\n}\r\n\r\n#factories {\r\n\twidth: 100%;\r\n}\r\n\r\n#toolbar-pane .tab-content > .tab-pane {\r\n\tpadding: 0px;\r\n}\r\n\r\n#left-rail .tab-pane{\r\n\tpadding: 0px;\r\n}\r\n\r\n.pf-control {\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n}\r\n\r\n.pf-control-core {\r\n\tcursor: default;\r\n\tdisplay: inline;\r\n\tfloat: left;\r\n}\r\n.drag-ghost {\r\n\tborder: 1px #111111 dashed;\r\n\tbackground-color: transparent;\r\n\tposition: absolute;\r\n\tleft: -30000px;\r\n\ttop: -30000px;\r\n\r\n\tz-index: 10000;\r\n}\r\n\r\n.propDetail {\r\n\twidth: 100%;\r\n\tmargin-bottom: 5px;\r\n\tdisplay: inline-block;\r\n}\r\n.propDetail label {\r\n\tfont-weight: normal;\r\n}\r\n\r\n.asset-control {\r\n\tfloat:left;\r\n\tpadding: 5px;\r\n\ttext-align: center;\r\n\theight: 50px;\r\n\twidth: 50px;\r\n}\r\n\r\n.asset-control label {\r\n\tfont-size: 10px;\r\n\tfont-weight: normal;\r\n}\r\n.asset-control:hover {\r\n\tcursor: pointer;\r\n\tbackground-color: #c0d382 !important;\r\n}\r\n.control-movie {\r\n\tbackground: #000;\r\n}\r\n\r\n.prop-label {\r\n\tfont-weight: bold;\r\n\tfont-size: 1.2rem;\r\n}\r\n\r\n.prop-sublabel {\r\n\tpadding-top: 5px !important;\r\n\tfont-size: 11px;\r\n}\r\n\r\n.prop-separator-0 {\r\n\tmargin-top: 0 !important; \r\n    padding-top: 0 !important;\r\n}\r\n\r\n.prop-separator-1 {\r\n\tmargin-top: 1px !important;  \r\n}\r\n\r\n.prop-separator-radio {\r\n\tpadding-top: 0 !important; \r\n\tmax-height: 16px;\r\n}\r\n\r\n.prop-sublabel-7 {\r\n\tpadding-top: 7px !important;\r\n}\r\n\r\n#propNavPosition div.nav-position.prop-detail input[type=\"text\"] {\r\n\twidth: 42px;\r\n}\r\n\r\nselect {\r\n\twidth: 100%;\r\n\theight: 32px;\r\n\tbackground-color: #fff;\r\n\tborder-radius: 4px;\r\n\tborder: 1px solid #bbb;\r\n}\r\n\r\n/* Spectrum Override */\r\n.sp-preview {\r\n\tposition: relative;\r\n\twidth: 15px;\r\n\theight: 15px;\r\n\tborder: solid 1px #222;\r\n\tmargin-right: 0px;\r\n\tfloat: left;\r\n\tz-index: 0;\r\n}\r\n\r\n.sp-dd {\r\n\tpadding: 2px 0;\r\n\theight: 16px;\r\n\tline-height: 16px;\r\n\tfloat: left;\r\n\tfont-size: 10px;\r\n\tdisplay: none;\r\n}\r\n\r\n.themeTextRows {\r\n\t/* padding-left: 15px; */\r\n}\r\n\r\n.themeTextRows .style-font-size {\r\n\twidth: 50px;\r\n}\r\n\r\n.themeTextRows .style-font {\r\n\twidth: 80px;\r\n}\r\n.themeTextRows label {\r\n\tfont-weight: normal;\r\n}\r\n\r\n.weightSelector, .styleSelector {\r\n\tborder: 1px solid #bbb;\r\n\tborder-radius: 4px;\r\n\theight: 32px;\r\n\twidth: 25px;\r\n}\r\n\r\n.themeTextRows .style-border-size, .themeTextRows .style-border-radius {\r\n\twidth: 50px;\r\n}\r\n\r\n.property-tabs .tab-pane {\r\n\twidth: 460px;\r\n}\r\n\r\n.pf-underline-dashboard{\r\n\tborder-bottom: 1px solid;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.pf-divider-vertical {\r\n\theight: 30px;\r\n\tmargin: 0 0 0 9px;\r\n\tpadding: 0 0 0 9px;\r\n\tborder-left: 1px solid darkgray;\r\n}\r\n\r\n.pf-disable{\r\n\tpointer-events: none;\r\n}\r\n\r\n.pf-enable{\r\n\tpointer-events: all;\r\n}\r\n\r\n\r\n.login-form .login-privacy-policy{\r\n\ttext-align: center;\r\n\tfont-size: 10px;\r\n\tmargin-top:10px!important;\r\n}\r\n\r\n.login-form {\r\n\twidth: 575px;\r\n\theight: auto;\r\n\tborder: 1px solid #ccc;\r\n\tbackground-color: #ffffff;\r\n\tposition: relative;\r\n\tborder-style: solid;\r\n\tborder-width: thin;\r\n\tborder-radius: 10px;\r\n\tpadding: 25px;\r\n\tbox-shadow: 0 2px 9px rgba(0,0,0,0.4);\r\n\tfont-size: 12px;\r\n\tdisplay: table;\t\r\n\tcolor:#333333;\r\n}\r\n\r\n\r\n.login-form .column-logo {\r\n\ttext-align: center;\r\n}\r\n\r\n.login-form img {\r\n\twidth: 285px;\r\n\theight: auto;\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.login-form .row {\r\n\tmargin: 0;\r\n}\r\n\r\n.login-form a {\r\n\tcolor: #333333;\r\n}\r\n\r\n\r\n\r\n.login-heading {\r\n\tbackground: var(--main-primary) !important;\r\n\tbackground-image: -moz-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n\tborder-top: 0px;\r\n\tcolor: #fff;\r\n\tpadding: 2px 5px;\r\n\tborder-top-left-radius: 1px;\r\n\tborder-top-right-radius: 1px;\r\n\theight: 30px;\r\n}\r\n\r\n.login-header-text{\r\n\tfont-weight: bold !important;\r\n\tfont-size: 18px;\r\n\tpadding-top: 3px;\r\n}\r\n\r\n.login-small-label{\r\n\tfont-size: 11px;\r\n}\r\n\r\n\r\n/*This solves an issue with bold on firefox(too bold)*/\r\n@-moz-document url-prefix() {\r\n\r\n}\r\n\r\n.login-form .login-data {\r\n\tmargin: 0 15px;\r\n}\r\n\r\n.login-container{\r\n\tmargin: 0 40px!important;\r\n}\r\n\r\n.login-container .login-data > .form-group > div, \r\n.login-container .login-data > .form-group > div  { \r\n\tpadding-left: 0;\r\n\tpadding-right: 0;\r\n\tmargin-bottom: 7px;\r\n}\r\n\r\n.login-container .login-data > .form-group > .no-margin { \r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.login-container .login-data .error-message { \r\n\ttext-align: center;\r\n}\r\n\r\n.login-container .login-data .error-message-text {\r\n\tmargin: 5px 0 4px 0;\r\n}\r\n\r\n.login-container .login-data .rememberme-content {\r\n\tdisplay: inline-flex; align-items: center; height: 25px;\r\n}\r\n\r\n.login-container .login-data .rememberme-content label {\r\n\tmargin: 0 0 0 5px; font-weight: normal;\r\n}\r\n\r\n.login-container .login-data .login-button {\r\n\ttext-align: center;\r\n}\r\n\r\n.login-container .login-data .login-button .button-login-align {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.login-container .login-data .captcha-container {\r\n\tmargin-bottom: 0;\r\n    margin-top: 5px;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.login-container .login-data .forgot-password {\r\n\tpadding-top:2px;\r\n\ttext-align: right;\r\n}\r\n\r\n.login-container .login-data .button-trial-account {\r\n\ttext-align: right; \r\n\tdisplay: block !important;\r\n}\r\n\r\n.login-container .login-data .message-shown-flash-mobile {\r\n\tdisplay: inline-flex; height: 252px; align-items: center;\r\n}\r\n \r\n.login-container .login-data .message-shown-flash-mobile > i {\r\n\tcolor: red; font-size: 25px; margin-right: 5px;\r\n}\r\n\r\n.login-container .login-data .message-shown-mobile {\r\n\tdisplay: inline-flex; align-items: center;\r\n}\r\n\r\n.login-container .login-data .message-shown-mobile  > i {\r\n\tcolor: orange; font-size: 25px; margin-right: 5px;\r\n}\r\n\r\n.login-container .login-data .message-shown-mobile  > label, \r\n.login-container .login-data .message-shown-flash-mobile > label {\r\n\tfont-weight: normal; line-height: normal; text-align: left;\r\n}\r\n\r\n\r\n.login-form .login-label{\r\n\tfont-weight: normal;\r\n}\r\n\r\n.login-form .login-data .form-control {\r\n\theight: 25px;\r\n\tfont-size: 12px;\r\n\tpadding: 4px 12px;\r\n}\r\n\r\n.login-form .btn-login{\r\n\tbackground: linear-gradient(var(--gradient-ToBottom));\r\n}\r\n\r\n.login-form .button-login {\r\n\twidth: 100px;\r\n\theight: 25px;\r\n\tborder-radius: 4px;\r\n\tfont-weight: bold;\r\n\tborder: 1px solid #d5d5d5;\r\n\tpadding: 0;\r\n\tfont-size: 12px;\r\n}\r\n\r\n@media screen and (max-width: 736px) { \r\n\t.login-form {\r\n\t\twidth: 100%;\t\t\r\n\t\theight: auto;\t\t \r\n\t\tdisplay: block;\t\r\n\t\tpadding: 10px;\r\n\t}\r\n\r\n\t.login-form .login-column {\r\n\t\tdisplay: block;\r\n\t\twidth: 100%;\t\r\n\t\theight: auto;\r\n\t\tmax-height: none;\r\n\t} \r\n}\r\n\r\n@media screen and (max-width: 400px) {  \r\n\t.login-form .column-logo img {\r\n\t\twidth: 80% !important;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 736px) and (orientation: landscape) { \r\n\t.login-form {\r\n\t\twidth: 80%;\r\n\t\theight: auto;\t\t \t\t \r\n\t\tpadding: 5px;\r\n\t}\r\n\r\n\t#newUser > div {\r\n\t\tmargin-bottom: 0;\r\n\t} \r\n\r\n\t.login-form .login-column img {\r\n\t\twidth: 50%;\r\n\t}\r\n}\r\n\r\n.login-background {\r\n\tbackground-color: #B7C2F4;\r\n\theight:100%;\r\n\tbackground: #a1bde2; /* For browsers that do not support gradients */\r\n\tbackground: -webkit-linear-gradient(#a1bde2, #ffffff); /* For Safari 5.1 to 6.0 */\r\n\tbackground: -o-linear-gradient(#a1bde2, #ffffff); /* For Opera 11.1 to 12.0 */\r\n\tbackground: -moz-linear-gradient(#a1bde2, #ffffff); /* For Firefox 3.6 to 15 */\r\n\tbackground: linear-gradient(#a1bde2, #ffffff); /* Standard syntax */\r\n}\r\n\r\n.login-main-container {\r\n\tdisplay: -ms-flexbox;      \r\n\tdisplay: -webkit-flex;\r\n\tdisplay: flex; \r\n    align-items: center;\r\n\tjustify-content: center;\r\n}\r\n\r\n\r\n\r\n.form-horizontal .form-group .form-control {\t \r\n\theight: 25px;\r\n\tpadding: 6px 12px;\r\n}\r\n\r\n \r\n#selectAccount #users-list {\r\n\theight: 70px;\r\n}\r\n\r\n\r\n.new-user-container .form-group div:nth-child(2) {\r\n\tdisplay: inline-flex;\r\n}\r\n\r\n.new-user-container .form-group div:nth-child(2) > .form-control {\r\n\twidth: 97%;\r\n}\r\n\r\n.new-user-container .form-group div:nth-child(2) > .control-label {\r\n\twidth: 3%;\r\n\tcolor: red;\r\n\ttext-align: right;\r\n\tpadding: 5px 0 0 0;\r\n    margin: 0;\r\n}\r\n\r\n\r\n.align-right {\r\n\tfloat: right;\r\n}\r\n\r\n\r\n.pre-scrollable {\r\n\toverflow-y: auto;\r\n}\r\n\r\n.error-message {\r\n\tcolor: #ff5f5f;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n#content {\r\n\theight: 100%;\r\n\tdisplay: inline !important;\r\n}\r\n\r\n\r\n/*\r\n#dynamic-filter, #override-previous{\r\n\tpadding: 0 0 0 0\r\n}\r\n\r\n#respect-dynamic-filter {\r\n\tpadding: 0 0 0 0;\r\n}\r\n*/\r\n\r\n\r\n#dashboard-main-panel .pf-btn-small{\r\n\tpadding:5px 5px 5px 5px\r\n}\r\n\r\n#propMainGridButtons .pf-btn-no-padding{\r\n\tpadding:5px 5px 5px 5px;\r\n\r\n}\r\n\r\n#propMainGridButtons button{\r\n\tfont-size: 11px;\r\n}\r\n#propMainGridButtons{\r\n\r\n}\r\n\r\nbutton.pf-sm-bootstrap-button{\r\n\tfont-size: 11px;\r\n}\r\n\r\n#gridButtonSection{\r\n\tpadding-left: 4px;\r\n}\r\n\r\n.selectSeparators{\r\n\twidth: 100% !important;\r\n}\r\n\r\n.input-style-border-radius{\r\n\twidth:50px !important;\r\n}\r\n\r\n.column-selection{\r\n\tbackground: rgba(0, 0, 0, 0.1) !important;\r\n\topacity: 0.5;\r\n\tborder-bottom: none gainsboro !important;\r\n}\r\n\r\n.help-margin-page {\r\n\tleft: 18px;\r\n}\r\n\r\n.help-margin-stage{\r\n\tright: 3px;\r\n\tmargin-top: 15px;\r\n}\r\n\r\n.ui-jqgrid > .ui-jqgrid-resize-mark, body > .ui-jqgrid-resize-mark{\r\n\tbackground-color: #777 !important;\r\n\twidth: 3px !important;\r\n}\r\n\r\n.emptyResizeColumn{\r\n\theight: 25px;\r\n\twidth:.3em;\r\n\tposition:relative;\r\n\tdisplay:inline;\r\n\toverflow: hidden;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n\tfloat: right;\r\n}\r\n\r\n.ui-tooltip {\r\n\twhite-space: pre-line;\r\n}\r\n\r\n.leftButton{\r\n\tmargin-right: 150px !important;\r\n}\r\n\r\nimg#modalResizeHandler {\r\n\tposition: absolute;\r\n\tbottom: 1px;\r\n\tright: 1px;\r\n}\r\n\r\n@media screen and (max-height: 500px) {\r\n\t#aForm {\r\n\t\toverflow-y: scroll;\r\n\t}  \r\n}\r\n\r\n@media (min-width: 1200px) {\r\n\t#nav-menu-mobile {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t#nav-menu-desktop {\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n\r\n\r\n@media (max-width: 1200px) {\r\n\t#nav-menu-mobile {\r\n\t\tdisplay: block;\r\n\t}\r\n\r\n\t#nav-menu-desktop {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t.navbar-nav > li {\r\n\t\tfloat: left !important;\r\n\t\tdisplay: block;\r\n\t\ttext-align: center; \r\n\t}\r\n\r\n\t.navbar-left > li a {\r\n\t\tpadding-left: 0 !important;\r\n\t}\r\n\r\n\t.quick-help .closed-tag{\r\n\t\tmargin-right: -28px!important;\r\n\t}\r\n}\r\n\r\n/*Refresh connections*/\r\n\r\n.refresh-actions {\r\n\tpadding-top: 2px;\r\n\tpadding-left: 8px;\r\n\ttext-align: end;\r\n}\r\n.refresh-actions-new {\r\n\tpadding-top: 0px;\r\n\tpadding-left: 8px;\r\n\ttext-align: end;\r\n}\r\n\r\n.noselect {    \r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -khtml-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\n#loading {\r\n\tdisplay: none;\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tbackground: rgba(0, 0, 0, 0.3);\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tz-index: 1109;\r\n\tfilter: alpha(opacity = 90);\r\n\topacity: 0.90;\r\n\t-ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity = 90);\r\n\tfilter: alpha(opacity = 90);\r\n}\r\n#loading-div {\r\n\twidth: 200px;\r\n\theight: auto;\r\n\tbackground-color: white;\r\n\ttext-align: center;\r\n\tposition: absolute;\r\n\tleft: 50%;\r\n\ttop: 50%;\r\n\tmargin-left: -150px;\r\n\tmargin-top: -100px;\r\n\tborder-radius: 5px;\r\n\tpadding-bottom:10px;\r\n\tpadding-top:10px;\r\n}\r\n\r\n.disable_a_href{\r\n    pointer-events: none;\r\n}\r\n\r\n.dropdown-menu > li > a > span.keyboard-shortcut,\r\n.dropdown-menu > li > a > span > span.keyboard-shortcut {\r\n\tfloat: right;\r\n    font-style: italic;\r\n    color: lightgrey;\r\n}\r\n\r\n.lstlink .dropdown-menu::before,\r\n.lstlink .dropdown-menu::after {\r\n\tborder: none;\r\n\tcontent: none;\r\n}\r\n\r\n.lstlink .navbar-btn {\r\n\tmargin-top:0px !important;\r\n\tmargin-bottom: 0px !important;\r\n}\r\n\r\n.close-icon-asset {\r\n\tborder: 1px solid transparent;\r\n\tbackground-color: transparent;\r\n\tdisplay: block;\r\n  \toutline: 0;\r\n\tcursor: pointer;\r\n}\r\n\r\n.close-icon-asset:after {\r\n\tcontent: \"X\";\r\n    display: block;\r\n    width: 15px;\r\n    height: 15px;\r\n    position: absolute;\r\n    background-color: var(--main-secondary);\r\n    z-index: 1;\r\n    top: 24px;\r\n    right: 20px; \r\n    margin: auto;\r\n    padding: 0;\r\n    border-radius: 50%;\r\n    text-align: center;\r\n    color: white;\r\n    font-weight: normal;\r\n    font-size: 12px;\r\n    box-shadow: 0 0 2px var(--main-secondary);\r\n    cursor: pointer;\r\n}\r\n\r\n.file-asset-import {\r\n\twidth: 90px !important;  border-radius: 4px !important; height: 28px !important;\r\n} \r\n\r\n#file-asset-label {\r\n\twidth: 25%; border-radius: 4px 0px 0px 4px; height: 30px;margin-top: -1px;\r\n}\r\n\r\n#file-asset-name {\r\n\twidth: 75%;height: 30px;\r\n\tborder-radius: 0 4px 4px 0px;\r\n    margin-left: -5px;\r\n    margin-bottom: 5px;\r\n    border: 1px solid #d5d5d5;\r\n    box-shadow: 0px 2px 5px #d5d5d5;\r\n    -moz-box-shadow: 0px 2px 5px #d5d5d5;\r\n    -webkit-box-shadow: 0px 2px 5px #d5d5d5;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n#asset-error-msg {\r\n\tmargin-left: 117px; color:red; font-weight: bold;\r\n}\r\n\r\n#assetViewerContainer {\r\n\ttext-align: center; height: 300px; width: 500px; display: none; vertical-align: middle;\r\n}\r\n\r\n.vertical{\r\n\tline-height: 25px;\r\n}\r\n.vertical input[type=text]{\r\n\tmargin-right: 5px;\r\n}\r\n.vertical img{\r\n\theight: 25px !important;\r\n\twidth: 25px !important;\r\n\tvertical-align: middle;\r\n\tmargin-top:-2px;\r\n}\r\n.calen-selected{\r\n\topacity: 0.4;\r\n}\r\n.calen-normal{\r\n\topacity: 1.0;\r\n}\r\n.tbl-icon{\r\n\twidth:  25px !important;\r\n\theight:  25px !important;\r\n\tfont-size:  16px !important;\r\n\tbackground: #ababab;\r\n\tpadding:  2px 2px !important;\r\n\tcolor: #ffffff;\r\n\tborder-right-color:  #a8a8a8;\r\n\tborder-bottom-color:  #a8a8a8;\r\n\tmargin-top: 2px;\r\n}\r\n\r\n.tbl-button-text{\r\n\theight:  25px !important;\r\n\tfont-size:  12px !important;\r\n\tpadding:  2px 2px !important;\r\n\tmargin-top: 2px;\r\n}\r\n\t\r\n\r\n.tbl-icon:hover, .tbl-icon-lst:hover{\r\n\tbackground: #ababab !important;\r\n\tcolor: #ffffff !important;\r\n\r\n}\r\n.tbl-icon-data-lst:hover, .tbl-icon-data-lst:active, .tbl-icon-data-lst:focus, .tbl-icon-data-lst:visited, .tbl-icon-data-lst:focus-within{\r\n\tbackground: #ababab !important;\r\n\tcolor: #ffffff !important;\r\n\t-webkit-box-shadow: none !important;\r\n\t-moz-box-shadow: none !important;\r\n\tbox-shadow: none !important;\r\n\r\n\tborder-right-color: #a8a8a8;\r\n\tborder-bottom-color: #a8a8a8;\r\n\tborder-top-color: rgb(213, 213, 213);\r\n\tborder-top-style: solid;\r\n\tborder-top-width: 1px;\r\n\tpointer-events: none;\r\n\r\n}\r\n\r\n.btn-ctrl-data{\r\n\tmargin: 0px;\r\n\theight: 20px;\r\n\twidth: 20px;\r\n}\r\n.btn-ctrl-datas{\r\n\tmargin: 0px;\r\n\theight: 20px;\r\n\twidth: 12px;\r\n\tmargin-left: 3px;\r\n\tmargin-right: 2px;\r\n}\r\n\r\n.tbl-icon-data-lst{\r\n\tpadding:2px 2px !important;\r\n\tmargin-top: 2px ;\r\n\tbackground: #ababab;\r\n\tcolor: #ffffff;\r\n\tborder-right-color:  #a8a8a8;\r\n\tborder-bottom-color:  #a8a8a8;\r\n\tcursor: default !important;\r\n\t-webkit-box-shadow: none;\r\n\t-moz-box-shadow: none;\r\n\tbox-shadow: none;\r\n\t-moz-user-select: -moz-none;\r\n\t-khtml-user-select: none;\r\n\t-webkit-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n\t-moz-user-select: none;\r\n\t/* Required to make elements draggable in old WebKit */\r\n\t-webkit-user-drag: element;\r\n\tpointer-events: none;\r\n}\r\n\r\n.no-box{\r\n\t-webkit-box-shadow: none;\r\n\t-moz-box-shadow: none;\r\n\tbox-shadow: none;\r\n}\r\n\r\n.tbl-icon-data-lst:hover{\r\n\tbackground: #ababab;\r\n\tcolor: #ffffff;\r\n\tborder-right-color:  #a8a8a8;\r\n\tborder-bottom-color:  #a8a8a8;\r\n\tcursor: default !important;\r\n\t-webkit-box-shadow: none;\r\n\t-moz-box-shadow: none;\r\n\tbox-shadow: none;\r\n}\r\n\r\n.tbl-icon-lst{\r\n\twidth:  25px !important;\r\n\theight:  25px !important;\r\n\tfont-size:  16px !important;\r\n\tbackground: #ababab;\r\n\tcolor: #ffffff;\r\n\tborder-right-color:  #a8a8a8;\r\n\tborder-bottom-color:  #a8a8a8;\r\n\tmargin-top: 2px;\r\n\tpadding: 1px !important;\r\n\tfloat: right;\r\n}\r\n#tableControls select{\r\n\t/*margin-left: 135px !important;*/\r\n\tright: 108px !important;\r\n\twidth: 61% !important;\r\n}\r\n\r\n#tableControls .itemSpaceEvenly{\r\n\tright: 0px !important;\r\n}\r\n\r\n#tableControls .itemRemove{\r\n\tright: 27px !important;\r\n}\r\n\r\n#tableControls .itemDown{\r\n\tright: 54px !important;\r\n}\r\n\r\n#tableControls .itemUp {\r\n\tright: 81px !important;\r\n}\r\n\r\n.context-item{\r\n\tfloat: left;\r\n}\r\n\r\n.actionName{\r\n\tdisplay: ruby;\r\n\twhite-space:nowrap;\r\n}\r\n\r\n.bootstrapMenu ul li a, #designerSave, #designerUndo, #designerRedo, #designerPaste, #designerCopy, #designerCut, #designerSelectAll {\r\n\tdisplay: grid !important;\r\n}\r\n\r\n.forceNotToShrink {\r\n\twidth: 100% !important;\r\n}\r\n#formulaModal .ui-datepicker-trigger{\r\n\theight: 25px !important;\r\n}\r\n.dateValueSpecific ~ img, .ui-datepicker-trigger{\r\n\theight: 25px !important;\r\n\twidth: 25px !important;\r\n\tvertical-align: middle;\r\n\tmargin-top:-1px;\r\n\tmargin-left: 3px !important;\r\n}\r\n.pf-icon-up{\r\n\t-moz-transform: rotate(-180deg);  /* FF3.5/3.6 */\r\n\t-o-transform: rotate(-180deg);  /* Opera 10.5 */\r\n\t-webkit-transform: rotate(-180deg);  /* Saf3.1+ */\r\n\ttransform: rotate(-180deg);  /* Newer browsers (incl IE9) */\r\n}\r\n.pf-icon-special-small{\r\n    width:1.3em;\r\n    top:3px;\r\n    left:-1px;\r\n}\r\n.pf-stack-icon-special{\r\n    top: -5px;\r\n    font-size: inherit;\r\n}\r\n.pf-icon-list-special{\r\n    font-size: 14px;\r\n    height: 32px;\r\n}\r\n.control-selected{\r\n\tborder: 1px dotted #ffffff;\r\n}\r\n\r\n.disable-select {\r\n    user-select: none; /* supported by Chrome and Opera */\r\n   -webkit-user-select: none; /* Safari */\r\n   -khtml-user-select: none; /* Konqueror HTML */\r\n   -moz-user-select: none; /* Firefox */\r\n   -ms-user-select: none; /* Internet Explorer/Edge */\r\n}\r\n\r\n#spinner-overlay {\r\n\tposition: fixed; /* Sit on top of the page content */\r\n\twidth: 100%; /* Full width (cover the whole page) */\r\n\theight: 100%; /* Full height (cover the whole page) */\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tbackground-color: rgba(0,0,0,0.05); /* Black background with opacity */\r\n\tz-index: 2; /* Specify a stack order in case you're using a different order for other elements */\r\n  }\r\n\r\n.navigation-objects-list{\r\n\tpadding: 7px 0px!important;\r\n}\r\n\r\n.refresh-dropdown{\r\n\tfont-size: 16px;\r\n    margin: 5px 0 0 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.website{\r\n\ttext-align: center;\r\n\tfont-family: Poppins;\r\n}\r\n\r\n.website a{\r\n\tcolor: var(--main-primary);\r\n    font-weight: bold;\r\n}\r\n\r\n/* Styles for the translate icon container */\r\n.input-with-icon {\r\n\tposition: relative;\r\n}\r\n.input-with-icon .app-title {\r\n\tpadding-right: 35px; \r\n\twidth: 100%; \r\n}\r\n\r\n.translate-icon {\r\n\tposition: absolute;\r\n\tright: 6px; \r\n\ttransform: translateY(-50%);\r\n\tcursor: pointer;\r\n\tcolor: #888;\r\n\topacity: 0.7;\r\n\ttransition: opacity 0.2s;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\theight: 100%;\r\n}\r\n\r\n/* top for inputs */\r\n.input-with-icon:not(.textarea-icon-wrapper) .translate-icon {\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%);\r\n}\r\n\r\n/* specific alignment for textareas */\r\n.textarea-icon-wrapper .translate-icon {\r\n\ttop: 30px; \r\n}\r\n\r\n.translate-icon:hover {\r\n\topacity: 1;\r\n}\r\n\r\n.translate-icon i {\r\n\tfont-size: 1.5rem;\r\n}\r\n\r\n.chat-bot{\r\n\tposition: fixed;\r\n    right: 0;\r\n    bottom: 0;\r\n    width: 80px;\r\n    height: 80px;\r\n    background-color: var(--accent-color, #F89B3C);\r\n    margin: 20px;\r\n    border-radius: 15px;\r\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\r\n    cursor: pointer;\r\n    z-index: 9999;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
